import { styled } from '@linaria/react';
import { bodyFont, fonts, semantic, space } from '../../theme/tokens';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  border: 1px solid ${semantic.border.default};
  border-radius: 8px;
  padding: ${space['space-600']};
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-300']};
`;

export const CardTitle = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
`;

export const NotesArea = styled.div`
  display: flex;
`;
